import { Component } from '@angular/core';
import { ROUTES } from './side-nav-routes.config';
import { ThemeConstantService } from '../../services/theme-constant.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './side-nav.component.html'
})
export class SideNavComponent {
  public menuItems: any[];
  isFolded: boolean;
  isSideNavDark: boolean;
  isExpand: boolean;

  constructor(private themeService: ThemeConstantService) {}

  ngOnInit(): void {
    const permissionsString = localStorage.getItem('permissions');
    let permissions: string[] = [];
    if (permissionsString) {
      try {
        permissions = JSON.parse(permissionsString);
      } catch (error) {
        console.error('Error parsing permissions:', error);
      }
    }

    if (permissions.length === 1 && permissions.includes('external_reporting')) {
      this.menuItems = [
        {
          path: 'apps/externalreports',
          title: 'Reports',
          iconType: 'nzIcon',
          iconTheme: 'outline',
          icon: 'fund',
          submenu: []
        }
      ];
    } else {
      this.menuItems = ROUTES.filter(menuItem => menuItem);
    }

    this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
    this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
    this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);
  }

  closeMobileMenu(): void {
    if (window.innerWidth < 992) {
      this.isFolded = false;
      this.isExpand = !this.isExpand;
      this.themeService.toggleExpand(this.isExpand);
      this.themeService.toggleFold(this.isFolded);
    }
  }
}
